"use client";

import { ShieldCheck } from "iconoir-react";
import { AdminContextBanner } from "./AdminContextBanner";

interface AdminOrgBannerProps {
  /** Name of the org this create flow was launched for, from admin-dash's "Create event" button. */
  orgName: string;
}

/**
 * Persistent notice shown across every step of the wizard when a Nowadays admin launched `/create`
 * from an org's admin-dash page (ENG-918), so it's never ambiguous whose event is being created. See
 * {@link AdminContextBanner} for the shared shell.
 *
 * @param props.orgName - Display name of the launched-for org.
 * @returns The banner element.
 */
export const AdminOrgBanner = ({ orgName }: AdminOrgBannerProps) => {
  return (
    <AdminContextBanner icon={<ShieldCheck className="h-4 w-4" strokeWidth={2} aria-hidden="true" />}>
      Admin: launched for <span className="font-semibold">{orgName}</span>
    </AdminContextBanner>
  );
};
